import * as permissions from "../permissions";

import { averroesAdmin, averroesUser } from "./handlers";
import { monitorAlertRead, monitorAlertWrite } from "./monitor-policy";
import { scheduledExecutionRead, scheduledExecutionWrite } from "./scheduled_execution-policy.js";

export default {
  [permissions.SCHEDULED_EXECUTION_READ]: scheduledExecutionRead,
  [permissions.SCHEDULED_EXECUTION_WRITE]: scheduledExecutionWrite,
  [permissions.MONITOR_ALERT_READ]: monitorAlertRead,
  [permissions.MONITOR_ALERT_WRITE]: monitorAlertWrite,
  [permissions.AVERROES_USER]: averroesUser,
  [permissions.AVERROES_ADMIN]: averroesAdmin,
};
